module.exports = __webpack_public_path__ + "r-v3/img/ml_19_00_over.f355a262.jpg";